export default "__VITE_ASSET__ChLDmUd5__"